import { makeAutoObservable } from 'mobx';

type DialogParams = {
    title?: string;
    message: string;
    confirmButtonTitle?: string;
    cancelButtonTitle?: string;
    icon?: React.ReactNode;
    onConfirm?: () => void;
    onCancel?: () => void;
    onClose?: () => void;
    isCaution?: boolean;
};

class DialogStore {
    isShowDialog = false;
    title: string = '';
    message: string = '';
    confirmButtonTitle: string = '확인';
    cancelButtonTitle: string = '취소';
    icon?: React.ReactNode = null;
    onConfirm?: () => void;
    onCancel?: () => void;
    onClose?: () => void;
    isCaution = false;

    constructor() {
        makeAutoObservable(this);
    }

    showDialog = ({ title = '', message, confirmButtonTitle = '확인', cancelButtonTitle = '취소', icon, onConfirm = undefined, onCancel = undefined, onClose = undefined, isCaution = false }: DialogParams) => {
        this.title = title;
        this.message = message;
        this.icon = icon;
        this.confirmButtonTitle = confirmButtonTitle;
        this.cancelButtonTitle = cancelButtonTitle;
        this.onConfirm = onConfirm;
        this.onCancel = onCancel;
        this.onClose = onClose;
        this.isShowDialog = true;
        this.isCaution = isCaution;
    };

    showAsyncDialog = ({ title = '', message, confirmButtonTitle = '확인', cancelButtonTitle = '취소', icon, isCaution = false }: DialogParams): Promise<boolean> => {
        return new Promise((resolve) => {
            this.showDialog({
                title: title,
                message: message,
                confirmButtonTitle: confirmButtonTitle,
                cancelButtonTitle: cancelButtonTitle,
                icon: icon,
                onConfirm: () => { resolve(true) },
                onCancel: () => { resolve(false) },
                onClose: () => { resolve(false) },
                isCaution: isCaution
            });
        })
    };

    hideDialog = () => {
        this.isShowDialog = false;
    };

    confirm = () => {
        this.onConfirm?.();
        this.hideDialog();
    };

    cancel = () => {
        this.onCancel?.();
        this.hideDialog();
    };

    close = () => {
        this.onClose?.();
        this.hideDialog();
    };
}

export const dialogStore = new DialogStore();